// ============================================================
// Client for the AI layer (Worker /api/ai, see the ADR).
// Every call resolves, never throws: when the API is unreachable
// (e.g. `yarn start` has no Worker) the caller's prepared answer is
// used. `mode` tells the UI who answered:
//   live     – Claude
//   demo     – no API key on the Worker, prepared answer
//   fallback – the call failed or was refused, prepared answer
//   offline  – no Worker at all (dev server), prepared answer
// ============================================================

export async function runAi(task, input, demo) {
  try {
    const res = await fetch(`/api/ai/${task}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (res.ok) {
      const body = await res.json();
      if (body && 'result' in body) return { mode: body.mode, result: body.result };
    }
  } catch {
    /* no Worker (dev server) or network error */
  }
  return { mode: 'offline', result: typeof demo === 'function' ? demo(input) : demo };
}

// { mode: 'live' | 'demo', model, tasks } or { mode: 'offline' }.
export async function aiStatus() {
  try {
    const res = await fetch('/api/ai/status');
    if (res.ok) return await res.json();
  } catch {
    /* fall through */
  }
  return { mode: 'offline' };
}
